<template>
  <div>
    <BreadCrumd :title="'Articles'" :description="'Liste des articles'" />

    <div class="mt-2 mb-4">
      <div class="row">
        <div class="col-md-6 col-lg-3" v-if="mode === 'tableau'">
          <multiselect
            v-model="selectedHeaders"
            :options="headers"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Filtrer par colonne"
            label="text"
            track-by="text"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen"
                >{{ values.length }}
                {{ values.length > 1 ? ' Colonnes' : 'Colonne' }}
              </span>
            </template>
          </multiselect>
        </div>
        <div class="col-md-6 col-lg-3">
          <multiselect
            v-model="selectedTypes"
            :options="articleTypes"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Filtrer par type"
            label="libelle"
            track-by="libelle"
            @input="onChangeFiltre"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen"
                >{{ values.length }}
                {{ values.length > 1 ? ' Sélections' : 'Sélection' }}
              </span>
            </template>
          </multiselect>
        </div>
        <div class="col-md-6 col-lg-3">
          <multiselect
            v-model="selectedTiers"
            :options="tiers"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Filtrer par tiers"
            label="nom"
            track-by="nom"
            @input="onChangeFiltre"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen"
                >{{ values.length }}
                {{ values.length > 1 ? ' Sélections' : 'Sélection' }}
              </span>
            </template>
          </multiselect>
        </div>
        <div
          class="text-right"
          :class="
            mode === 'tableau' ? 'col-md-6 col-lg-3' : 'col-md-12 col-lg-6'
          "
        >
          <a
            v-if="mode === 'tableau'"
            title="Mode d'affichage catalogue"
            class="cursor-pointer mr-4"
            @click="setMode"
          >
            <i class="fas fa-table font-size-20"></i
          ></a>
          <a
            v-if="mode === 'catalogue'"
            title="Mode d'affichage tableau"
            class="cursor-pointer mr-4"
            @click="setMode"
          >
            <i class="fas fa-list font-size-20"></i
          ></a>

          <button
            type="button"
            class="btn btn-custom-primary"
            @click.prevent="
              $router.push({ name: 'achat_article-create' }).catch(() => {})
            "
          >
            <i class="fas fa-plus"></i>
            Nouvel article
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <component
          :headers="selectedHeaders"
          ref="datatable"
          @onSelect="onSelectRows"
          @onRowsDelete="deleteRows"
          :is="currentMode"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from './mode_affichage/DataTable.vue';
import DataIterator from './mode_affichage/DataIterator.vue';
import URL from '@/http/article_stock/article';

import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      title: 'Gestion des articles',
      currentMode: DataTable,
      isSelect: false,
      selectedTypes: [],
      selectedTiers: [],
      tiers: [],
      selectedHeaders: [],
      headers: [
        {
          text: 'Référence',
          align: 'start',
          sortable: true,
          value: 'reference',
        },
        {
          text: 'Désignation',
          align: 'start',
          sortable: true,
          value: 'designation',
        },
        {
          text: 'Dernier fournisseur',
          align: 'start',
          sortable: true,
          value: 'fournisseur',
        },
        {
          text: "Type d'article",
          align: 'start',
          sortable: true,
          value: 'article_type',
        },
        {
          text: 'Achat ?',
          align: 'start',
          sortable: false,
          value: 'achat',
        },
        {
          text: 'Vente ?',
          align: 'start',
          sortable: false,
          value: 'vente',
        },
        {
          text: 'Lot ?',
          align: 'start',
          sortable: false,
          value: 'lot',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('article', ['mode', 'articleTypes']),
  },
  created() {
    this.selectedHeaders = this.headers;
    if (this.mode === 'tableau') this.currentMode = DataTable;
    else this.currentMode = DataIterator;
  },
  watch: {
    mode(val) {
      if (val === 'tableau') this.currentMode = DataTable;
      else this.currentMode = DataIterator;
    },
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    ...mapActions('article', ['setMode']),
    init() {
      this.tiers = [];

      window.axios
        .get(URL.GET_REQUIREMENTS, {
          params: {
            filter: true,
          },
        })
        .then((resp) => {
          this.tiers = resp.data.tiers;
        })
        .catch();
    },
    onChangeFiltre() {
      let tiers = this.selectedTiers.map((t) => t.uuid);
      let types = this.selectedTypes.map((t) => t.id);
      this.$nextTick(() => {
        this.$refs.datatable.setFilter(types, tiers);
        this.$refs.datatable.loadItems();
      });
    },

    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.ARTICLE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
  },
};
</script>

<style scoped></style>
